<template>
    <div class="page-wrapper">
        <div class="subject-details-wrapper">
            <!-- 特殊专题 -->
            <SubjectSpecial v-if="id === 'MTE3MTY='" :columnId="columnId" :banner="banner" :sData="sData"/>
            <!-- 普通专题 -->
            <div class="subject-img-title" v-if="id !== 'MTE3MTY=' && sData">
                <div v-if="isPhone" class="img" :style="{'background-image': 'url('+sData.images.img169+')'}">
                    <img style="opacity: 0" :src="sData.images.img169" :onerror="errorImg">
                </div>
                <div v-else class="img" :style="{'background-image': 'url('+sData.images.img51+')'}">
                    <img style="opacity: 0" :src="sData.images.img51" :onerror="errorImg">
                </div>
                <div class="text" v-if="sData.brief">
                    <div class="title">{{sData.name}}</div>
                    <p class="brief">{{sData.brief}}</p>
                </div>
            </div>
            
            <div v-if="useSubjectKind === 0" class="subject-wrapper">
                <NewsList :list="list" :type="2" :subjectId="id" :isNeedSubjectId="true" />
            </div>
            <div v-if="useSubjectKind === 1" class="subject-classify-wrapper">
                <div class="subject-classify" v-for="item in list" :key="item.id">
                    <div v-if="item.list && item.list.length" class="subject-classify-title clearfix"">
                        <div class="title">{{item.name}}</div>
                        <div v-show="!isPhone && item.list && item.list.length > 12" class="seeMore pointer" @click="seeMore(item)">查看全部&nbsp;>&nbsp;
                        </div>
                        <div v-show="isPhone && item.list && item.list.length > 5" class="seeMore pointer" @click="seeMore(item)">查看全部
                            <img src="./../assets/img/wap_seeMore.png" alt="">
                        </div>
                    </div>
                    <div v-if="item.list && item.list.length">
                        <NewsList v-if="isPhone" :list="item.list.slice(0, 5)" :isNeedSubjectId="true"/>
                        <NewsList v-else :list="item.list.slice(0, 12)" :type="2" :subjectId="id" :isNeedSubjectId="true" :skId="$Common.Base64.encode(item.id)" />
                    </div>
                </div>
            </div>
        </div>
        <div v-show="isLoading || lastDataId == -1" class="loadMore">
            <div class="loadMoreInner" :class="{'isSpecial': isSpecial == 1}">{{lastDataId == -1 ? '已经到底了' : '加载更多'}}</div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>
import SubjectSpecial from "@/components/SubjectSpecial";
import NewsList from '@/components/NewsList';
import GoHome from '@/components/GoHome.vue';
import { mapMutations, mapState } from 'vuex';
export default {
    name: 'SubjectDetail',
    data() {
        return {
            page: 1,
            id: null,
            sData: null,
            list: [],
            isLoading: false,
            lastDataId: null,
            errorImg: `this.parentNode.style.backgroundImage = 'url("${require('./../assets/img/default.png')}")'`, // 头图加载失败
            useSubjectKind: 0, // 0-无分类 1-有分类
            isSpecial:-1, // -1默认状态 0不是特殊频道 1是特殊频道
            banner: [] // 特殊专题幻灯
        }
    },
    components: {
        SubjectSpecial,
        NewsList,
        GoHome
    },
    created() {
        this.setIsSubject(true);
        // 获取列表数据
        this.id = this.$route.params.id;
        if(this.id === 'MTE3MTY='){
            this.setIsSpecial(1)
            this.isSpecial = 1
        }else{
            this.setIsSpecial(0)
            this.isSpecial = 0
        }
        this.getDetail();
    },
    watch: {
        $route(val) {
            if(val.params.id && this.id != val.params.id) {
                this.setInit();
                this.id = val.params.id;
                this.getDetail()
            }
        }
    },
    methods: {
        ...mapMutations(['setLoadingShow','setIsSubject','setIsSpecial']),
        getDetail() {
            if(!this.$Common.Base64.decode(this.id)) {
                return;
            }
            const params = {
                subjectId: this.$Common.Base64.decode(this.id),
                pageSize: this.pageSize,
                queryAllImg: true
            }
            if (this.lastDataId) {
                params.lastDataId = this.lastDataId
            }
            if(this.isPhone) params.queryAllImg = true
            this.isLoading = true;
            this.$axios.post(this.$ApiInfo.getSubjectDetail,params).then(res => {
                if(res.subject && res.subject.name) document.title = res.subject.name
                this.isPhone && res.share && this.$Common.onShare({
                    shareTitle: res.share.shareTitle,
                    shareBrief: res.share.shareBrief,
                    shareUrl: window.location.href,
                    // shareImg: res.share.shareImg
                })
                this.sData = res.subject
                this.lastDataId = res.lastDataId
                this.useSubjectKind = res.useSubjectKind
                this.list = res.useSubjectKind ? res.subjectKindList : res.list
                if(res.banner && res.banner.length) {
                    this.banner = res.banner
                }
                if(res.useSubjectKind === 0 && this.lastDataId != -1) { // 代表是无分类，绑定下拉加载
                    this.$nextTick(()=> {
                        let footerHeight = 0;
                        document.querySelector('.footer-wrapper') && document.querySelector('.footer-wrapper').clientHeight > 0 && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 50)
                        this.$Common.loadScroll(footerHeight, this.update)
                    })
                }
                this.setLoadingShow(false);
                this.isLoading = false;
            })
        },
        update() {
            if(this.isLoading || this.lastDataId == -1 || !this.$Common.Base64.decode(this.id)) {
                return;
            }
            const params = {
                subjectId: this.$Common.Base64.decode(this.id),
                pageSize: this.pageSize,
            }
            if (this.lastDataId) {
                params.lastDataId = this.lastDataId
            }
            this.isLoading = true;
            if(this.isPhone) params.queryAllImg = true
            this.$axios.post(this.$ApiInfo.getSubjectDetail,params).then(res => {
                this.isLoading = false;
                this.lastDataId = res.lastDataId
                this.list = res.useSubjectKind ? this.list.concat(res.subjectKindList) : this.list.concat(res.list)
            })
        },
        seeMore(item) { // 查看更多
            window.open(this.$router.resolve({
                path: `/list/${this.$Common.Base64.encode(5)}/${this.id}/${this.$Common.Base64.encode(item.id)}`
            })['href'], '_blank');
        },
        setInit() {
            this.id = null;
            this.sData = null;
            this.list = [];
            this.isLoading = false;
            this.lastDataId = null;
        }
    },
    computed: {
        isPhone() {
            return this.$Common.Attribute.isMb();
        },
        pageSize() {
            return this.isPhone ? 20 : 45;
        }
    },
}
</script>
<style lang="less" scoped>
.subject-details-wrapper {
    width: 100%;
    .subject-img-title {
        width: 100%;
        height: auto;
        margin-bottom: 1.5rem;
        .img {
            display: block;
            width: 100%;
            height: 12.75rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-image: url('./../assets/img/default.png');
        }
        .text {
            padding: 1.25rem 1.5625rem;
            background: #fff;
            color: #333333;
            .title {
                font-size: 1.375rem;
                line-height: 1.875rem;
            }
            .brief {
                font-size: 1.25rem;
                line-height: 1.75rem;
            }
        }
    }
    .subject-classify-wrapper {
        .subject-classify {
            .subject-classify-title {
                color: #006df1;
                border-left: 0.1875rem solid #006df1;
                text-indent: .5em;
                margin-bottom: 0.875rem;
                line-height: 1.125rem;
                &.isSpecial{
                   color: #385C40;
                   border-left: 0.1875rem solid #385C40; 
                    .seeMore {
                        color: #385C40; 
                    }
                }
                .title {
                    float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  color:#006DF1;
                  float: right;
                  img {
                    width: 0.3125rem;
                    height: 0.4375rem;
                  }
                }
            }
        }
    }
}

.wap-wrapper {
    .subject-details-wrapper {
        width: 100%;
        .subject-img-title {
            width: 100%;
            height: auto;
            margin-bottom: 5.333vw;
            position: relative;
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
            .text {
                width: 100%;
                box-sizing: border-box;
                padding: 6.8vw 4vw 4.4vw;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
                color: #fff;
                position: absolute;
                bottom: 0;
                .title {
                    display: none;
                }
                .brief {
                    font-size: 4.533vw;
                    line-height: 6.4vw;
                }
            }
        }
        .subject-classify-wrapper {
            .subject-classify {
                .subject-classify-title {
                    color: #006df1;
                    margin-bottom: 3.067vw;
                    line-height: 4.8vw;
                    font-size: 4.8vw;
                    padding: 0 4vw;
                    box-sizing: border-box;
                    border-left: none;
                    &.isSpecial{
                        color: #385C40;
                        padding-top:4.4vw;
                    }
                    .title {
                        border-left: 2px solid #006df1;
                        text-indent: .5em;
                        float: left;
                    }
                    &.isSpecial{
                        .title {
                           border-left: 2px solid #385C40; 
                        }
                    }
                    .seeMore {
                        font-size: 3.2vw;
                        line-height: 4.8vw;
                        float: right;
                        color:#666666;
                        img {
                            width: 1.6vw;
                            height: 2.667vw;
                        }
                    }
                }
            }
        }
    }
}
</style>